export function Title({ children, color }) {
    return (
        <h1 className="text-5xl text-pink uppercase font-bold flex mb-10">
            <span className="hidden xs:inline xs:w-32 w-40 h-1 bg-pink self-center xs:mr-6 mr-10"></span>
            {children}
        </h1>
    )
}